import { render, staticRenderFns } from "./trandingCollection.vue?vue&type=template&id=0da13e4e&scoped=true"
import script from "./trandingCollection.vue?vue&type=script&lang=js"
export * from "./trandingCollection.vue?vue&type=script&lang=js"
import style0 from "./trandingCollection.vue?vue&type=style&index=0&id=0da13e4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da13e4e",
  null
  
)

export default component.exports